var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndustry(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f7f7;}.cls-2{fill:none;stroke:#b53729;stroke-width:4px;}.cls-3{fill:#b53729;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 85,
    cy: 85,
    r: 85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.9,92.8V78.67l-10.28-.85A40.43,40.43,0,0,0,117.89,63l6.9-8.15-10-10-7.88,6.66a40.56,40.56,0,0,0-14.51-6.4l-.88-10.63H77.4l-.85,10.28a40.23,40.23,0,0,0-14.79,5.74l-8.14-6.9-10,10,6.66,7.88A40.41,40.41,0,0,0,43.89,76l-10.63.89V91l10.28.85a40.39,40.39,0,0,0,5.73,14.79l-6.89,8.14,10,10,7.87-6.66a40.38,40.38,0,0,0,14.51,6.4l.88,10.63H89.77l.85-10.27a40.61,40.61,0,0,0,14.78-5.74l8.15,6.89,10-10-6.66-7.87a40.73,40.73,0,0,0,6.4-14.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.63,55.64a28.93,28.93,0,0,1,11.73,2.48,29.22,29.22,0,1,1-11.73-2.48m0-4a33.22,33.22,0,0,0-13.44,63.62,32.92,32.92,0,0,0,13.35,2.82,33.22,33.22,0,1,0,.09-66.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114,89.17l-4.51,2.59-7.33,6.17-.33-6L97,92.8l-.54-5.51L93.23,89l-.94-.73L89.47,85.5l-.89,3.83,2.15,2.17-9.42,9.16-2.56.4,0-4.94,1.85-7.47L77.22,87l-.34-3.22,4.25-4.46,3.15.58,1.26,2,1.15-3.75-3.57-2.36.31-1.25L88.1,74l-.52-3.13,5.29-1.76,3.41,3.18,7.61.85,7.15-.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75,55.17l-1.7,3.48-4.77,3.67a.48.48,0,0,0-.17.42l.55,3.78a.52.52,0,0,0,.27.35.44.44,0,0,0,.43-.05l2.69-1.88,1.47,5.22-8.5,2.77-3.6-1.19a.44.44,0,0,0-.47.12l-1.68,1.79a.45.45,0,0,0-.1.42l1,4-3-3.35-2.62-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.8,89.05l-.34-5.65,4.91-4.47,4.37,9.76L58.1,98.57v-3.4l2.66-5.91A.52.52,0,0,0,60.8,89.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.53,67l-.24-7.64a26.7,26.7,0,0,1,9.65.88L85.1,65.51Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default __webpack_public_path__ + "static/media/industry.f90dc79375ad60a8d4bd45fdd4fa7891.svg";
export { ForwardRef as ReactComponent };